import { type FC } from "react";

import { SampleLockedIcon } from "@/ui-modules/core/tiles/components/SampleTile.tsx";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import { TableCell } from "./TableCell.js";

const LockedCell: FC<IAgGridCellProps> = (props) => {
  if (props.data) {
    return <TableCell>{props.data?.locked && <SampleLockedIcon size={15} />}</TableCell>;
  }

  return null;
};

export default LockedCell;
